module.exports = __webpack_public_path__ + "static/media/online.a2465140.jpg";